<template>
  <div>
    <FormFieldLabel v-if="label" :for="`${name}_input`">
      {{ label }}
    </FormFieldLabel>
    <div class="relative rounded-md">
      <input
        :id="`${name}_input`"
        :type="type"
        :name="name"
        :class="[
          'block w-full rounded-md border border-background-fg/8 text-sm font-semibold focus:outline-none sm:text-sm',
          hasError
            ? 'border-error text-error placeholder:text-error focus:border-error focus:ring-error'
            : 'focus:border-primary focus:ring-primary',
        ]"
        :placeholder="placeholder"
        :value="inputValue"
        :aria-invalid="hasError"
        enterkeyhint="done"
        :disabled="disabled"
        :maxlength="maxlength"
        :pattern="pattern"
        @change="handleChange"
        @blur="handleBlur"
      />
    </div>
    <template v-if="hasError">
      <p class="mt-1 text-xs font-medium text-error">
        {{ errorMessage }}
      </p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"

const props = withDefaults(
  defineProps<{
    type?: string
    name: string
    label: string
    placeholder?: string
    disabled?: boolean
    maxlength?: number
    pattern?: string
  }>(),
  {
    modelValue: "",
    type: "text",
    placeholder: "",
    disabled: false,
    maxlength: undefined,
    pattern: undefined,
  }
)

const name = toRef(props, "name")

const {
  value: inputValue,
  errorMessage,
  handleBlur,
  handleChange,
} = useField(name)

const hasError = computed(() => !!errorMessage.value)
</script>
